import { Component, enableProdMode, ViewContainerRef } from '@angular/core';
import { UpdateAppService } from './shared/services/update-app.service';
import { environment } from 'environments/environment';

if (environment.production) {
  enableProdMode();
}

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent {
    public title = 'app works!';

    public constructor(private viewContainerRef: ViewContainerRef, private updateAppService: UpdateAppService) {
    }
    async ngOnInit() {
        await this.updateAppService.getServiceWorkerInfo();
        this.updateAppService.checkForUpdates();
    }
}